import React from "react";
import { Avatar, Box, Grid, Icon, styled, Typography } from "@mui/material";
import CardData from "../../shared/dashboard/CardData";
import Utils from "../../../../utils";
import ChartAreaCustom from "../../shared/dashboard/ChartArea";
import dayjs from "dayjs";
import CardDashboard from "../../shared/dashboard/CardDashboard";
import { useSelector } from "react-redux";
import ChartDonutCustom from "../../shared/dashboard/ChartDonut";
import OT36Dialog from "./OT36Dialog";

const StyledRoot = styled(Box)({
  "& .top-employee": {
    padding: "8px",
    // paddingTop: "16px",
    display: "flex",
    alignItems: "center",
    border: "1px solid #ececec",
    borderRadius: "4px"
  }
})

const OvertimePanel = (props) => {

  const { month, year, realEmployee, realCost, realOT, fetchOT36, activeEmpMap, headcountByDept, empLoading, costLoading } = props;
  const otRates = realCost
    ? [
        { name: "OT x1", value: Number(realCost.totalOT1) || 0 },
        { name: "OT x1.5", value: Number(realCost.totalOT15) || 0 },
        { name: "OT x2", value: Number(realCost.totalOT2) || 0 },
        { name: "OT x3", value: Number(realCost.totalOT3) || 0 },
        { name: "OT เหมาจ่าย", value: Number(realCost.totalOTMonth) || 0 },
      ].filter((r) => r.value > 0)
    : [];

  const {result: dashboardOvertime} = useSelector(state => state.dashboardOvertime);

  const top5Over36 = (dashboardOvertime.employeeOTOver36Total.top5EmployeeOver36 || []).filter(
    (e) => !activeEmpMap || activeEmpMap.has(e.idEmp)
  );

  return (
    <StyledRoot>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={8}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <CardData
                    title="พนักงาน"
                    loading={empLoading && !realEmployee}
                    dataValue={Utils.numberWithCommasWithoutDot(realEmployee ? realEmployee.employeeTotal : dashboardOvertime.employeeTotal)}
                    dataUnit="คน"
                    dynamicFontSize
                    titleIcon={
                      <Icon baseClassName="fal" className="fa-users" color="primary" style={{display: "inline-table" }}/>
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <CardData
                    title="รายจ่ายค่าล่วงเวลา"
                    loading={costLoading && realOT == null}
                    dataValue={realOT == null ? "0" : Utils.numberWithCommas(realOT)}
                    dataUnit="บาท"
                    dynamicFontSize
                    titleIcon={
                      <Icon className="fal fa-hand-holding-usd" color="warning" style={{display: "inline-table", color: "#ffcd38"}}/>
                    }
                  />
                </Grid>
                {/* ลบการ์ด "ทำงานล่วงเวลา (ชม.)" ออก — ไม่มีข้อมูลจริง (เคยเป็นค่าประมาณ) */}
              </Grid>
            </Grid>
            <Grid item xs={12} lg={4}>
              <CardData
                title="OT เกิน 36 ชั่วโมง"
                dataValue={dashboardOvertime.employeeOTOver36Total.weekInMonth.map(week => {return {name: `${dayjs(week.weekStartDateText).format("dd D MMM")} - ${dayjs(week.weekEndDateText).format("dd D MMM")}`, value: week.over36HoursEmployee ? week.over36HoursEmployee.filter(e => !activeEmpMap || activeEmpMap.has(Number(e.idEmp))).length : week.over36HoursEmployeeTotal}})}
                dataUnit="คน"
                dynamicFontSize
                select
                titleIcon={
                  fetchOT36 ? (
                    <OT36Dialog fetchOT36={fetchOT36} month={month} year={year} />
                  ) : (
                    <Icon className="far fa-alarm-exclamation" color="error" style={{display: "inline-table" }}/>
                  )
                }
              />
            </Grid>
          </Grid>
        </Grid>

        {/* <Grid item xs={12}>
          <CardDashboard>
            <Typography marginBottom="16px">รายจ่ายค่าล่วงเวลา (รายปี {year})</Typography>
            <ChartAreaCustom
              series={[
                {
                  name: "รายจ่าย",
                  data: dashboardOvertime.otTotalAllYear.map(s => {return {x: dayjs().month(s.month-1).format("MMM"), y: s.payTotal}})
                }
              ]}
            />
          </CardDashboard>
        </Grid> */}

        <Grid item xs={12}>
          <Grid container spacing={2}>
            {/* OT แยกตามเรท (ข้อมูลจริงจาก PayrunDetail) */}
            <Grid item xs={12} lg={6}>
              <CardDashboard>
                <Typography marginBottom="16px">OT แยกตามเรท</Typography>
                {otRates.length > 0 ? (
                  <ChartDonutCustom
                    series={otRates.map((r) => r.value)}
                    labels={otRates.map((r) => r.name)}
                  />
                ) : (
                  <Typography textAlign="center" color="text.third">
                    {realCost ? "ไม่มีข้อมูล OT" : "ยังไม่ปิดงวด / กำลังโหลด"}
                  </Typography>
                )}
              </CardDashboard>
            </Grid>

            <Grid item xs={12} lg={6}>

              <CardDashboard>
                <Typography marginBottom="16px">5 อันดับ ทำงานล่วงเวลาเกิน 36 ชม.</Typography>
                {top5Over36.length > 0 && (
                  <Box style={{display: "flex", gap: "16px", flexDirection: "column"}}>
                    {top5Over36.map((e, index) => (
                      <Box key={index} className="top-employee">
                        <Icon className={`fa-solid fa-square-${index+1}`} color="primary" style={{display: "inline-table", color: index <= 2? "#ffcd38": undefined}}/>
                        <Box style={{flexGrow: "1", display: "flex", alignItems: "center"}}>
                          <Avatar src={e.imageProfile} style={{marginRight: "8px", width: "32px", height: "32px"}}/>
                          <Typography>{e.firstname} {e.lastname}</Typography>
                        </Box>
                        <Typography>{e.over36Total} ครั้ง</Typography>
                      </Box>
                    ))}
                  </Box>
                )}
                {top5Over36.length <= 0 && (
                  <Typography textAlign="center" color="text.third">ไม่มีการทำเกิน 36 ชม.</Typography>
                )}
              </CardDashboard>
            </Grid>

          </Grid>
        </Grid>


      </Grid>
    </StyledRoot>
  )
}

export default OvertimePanel;